export const isValidValue = (value) => {
    if (
        value === undefined ||
        value === null ||
        value === 0 ||
        value?.trim() === ''
    ) {
        return false;
    }
    return true;
};
export const findParent = (element) => {
    let parentElement = element.parentNode;
    for (let i = 0; i < 12; i++) {
        if (parentElement.classList.contains('parent')) {
            return parentElement;
        } else {
            parentElement = parentElement.parentNode;
        }
    }
    return null;
};
export const CheckValidation = ({ formID }) => {
    let isValid = true;
    const formElement = document.getElementById(formID);
    const inputs = formElement.querySelectorAll('select, textarea, input');
    const datePickers = formElement.querySelectorAll('.custom-react-datepicker[data-required="true"]');

    inputs.forEach((input) => {
        if (input.disabled) {
            return; // Skip validation for disabled inputs
        }
        if (!input.required) {
            return;
        }
        const inputParent = findParent(input);
        if (inputParent && !inputParent.classList.contains('d-none')) {
            const invalidFeedback = input.parentNode.querySelector('.invalid-feedback');
            if (input.tagName == 'SELECT' && input.value === '0') {
                invalidFeedback.style.display = 'block';
                isValid = false;
            } else if (input.type == 'number' && input.value < 0) {
                invalidFeedback.style.display = 'block';
                isValid = false;
            } else if (!isValidValue(input.value)) {
                invalidFeedback.style.display = 'block';
                isValid = false;
            } else {
                invalidFeedback.style.display = '';
            }
        }
    });

    datePickers.forEach((pickerWrapper) => {
        const input = pickerWrapper.querySelector('input');
        const invalidFeedback = pickerWrapper.parentNode.querySelector('.invalid-feedback');

        if (!input || !input.value.trim()) {
            if (invalidFeedback) invalidFeedback.style.display = 'block';
            isValid = false;
        } else {
            if (invalidFeedback) invalidFeedback.style.display = '';
        }
    });

    return isValid;
}

//All the parameters are important for the ValidateFile function
export const ValidateFile = (file, { allowedType = "", maxSizeMB = 2 } = {}) => {
    if (!file) return { isFileValid: false, validationMsg: "No file provided." };

    const fileType = file.type.toLowerCase();
    const mimeGroups = {
        pdf: ["application/pdf"],
        csv: ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
        image: ["image/jpeg", "image/png", "image/jpg"],
    };

    const normalized = allowedType.toLowerCase();
    const allowedMimes = mimeGroups[normalized];

    const isMimeValid = allowedMimes.includes(fileType);
    const errorMsgs = {
        pdf: "You can only uplaod PDF file!",
        csv: "You can only uplaod CSV file!",
        image: "Please upload JPEG, JPG, PNG or SVG files only."
    }
    if (!isMimeValid) return { isFileValid: false, validationMsg: errorMsgs[normalized], };

    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) return { isFileValid: false, validationMsg: `${file.name} file size exceeds ${maxSizeMB}MB. Please upload a smaller file.` };

    return { isFileValid: true, validationMsg: "File is valid." };
};